module.exports = __webpack_public_path__ + "img/mouth_male_thick.aecd30e9.png";